if (!customElements.get('search-bar')) {
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = $('#predictive-search').get(0);
    this.searchInput = this.querySelector('.search__input');
    this.closeButton = this.querySelector('.search-bar__close');
    this.HeaderTop = this.closest('header-top-section');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        $('#predictive-search').get(0).setAttribute('style', 'display:none !important');
        this.HeaderTop.closeSearchBar({
          refocus: true,
        });
      });
    }

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        text = JSON.parse(new DOMParser().parseFromString(text, 'text/html').querySelector('body').innerHTML).resources.results.products;
        var resultsMarkup = '';
        var bigWrapper = document.createElement('div');
        text.forEach(result => {
          var wrapper = document.createElement('div');
          wrapper.classList.add('product-card');
          var linkWrapper = document.createElement('a');
          wrapper.appendChild(linkWrapper);
          linkWrapper.setAttribute('href', result.url);
          var imageWrapper = document.createElement('div');
          linkWrapper.appendChild(imageWrapper);
          imageWrapper.classList.add('img-container');
          var image = document.createElement('img');
          image.setAttribute('src', result.image);
          imageWrapper.appendChild(image);
          var title = document.createElement('h4');
          title.innerHTML = result.title;
          linkWrapper.appendChild(title);
          var price = document.createElement('p');
          price.classList.add('product-price');
          price.innerHTML = '$ ' + result.price;
          var description = result.body.split('{short_description}');
          if(description[1] !== undefined){
            description = description[1].split('{/short_description}')[0]
            var desc = document.createElement('p');
            desc.classList.add('product-description');
            linkWrapper.appendChild(desc);
          }
          linkWrapper.appendChild(price);
          bigWrapper.appendChild(wrapper);
        });
        
        $('#predictive-search').get(0).innerHTML = bigWrapper.innerHTML;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    $('#predictive-search').get(0).style.display = 'block';
  }

  close() {
    $('#predictive-search').get(0).style.display = 'none';
  }

  activateExpand() {
    this.searchInput.focus();
    
  }

  expandFocusOut(event) {
    if (event.relatedTarget === null || !this.contains(event.relatedTarget)) {
      this.HeaderTop.closeSearchBar();
    }
  }


  expandKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.HeaderTop.closeSearchBar({
      refocus: true,
    });
  }
}
function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
customElements.define('search-bar', PredictiveSearch);
}